import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { userSlice } from '../../store/reducers/userReducer';
import { uiSlice } from '../../store/reducers/uiReducer';

import WeaponSlots from '../../assets/img/item_slots/Weapon.png'
import WeaponSlotsWebp from '../../assets/img/item_slots/Weapon.webp'
import shieldSlots from '../../assets/img/item_slots/Shield.png'
import shieldSlotsWebp from '../../assets/img/item_slots/Shield.webp'
import ToolTip, { IToolTipObject } from '../ui/ToolTip';
import ImgWithFallback from '../ui/ImgWithFallback';

const CharacterWindowWeapon = () => {
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const characterInventory = useAppSelector(state => state.userReducer.character.getInventory())
    const dispatch = useAppDispatch()
    const { setInventoryLength } = userSlice.actions
    const { setToolTipContent } = uiSlice.actions
    const toolTipContent = useAppSelector(state => state.uiReducer.toolTipContent)
    // state
    const [isToolTipView, setIsToolTipView] = useState(false)

    const handleRemoveItem = useCallback(() => {
        if (mainCharacter.getEquipment().weapon.getWeaponType()) {
            mainCharacter.getEquipment().weapon.remove(mainCharacter, characterInventory)
            dispatch(setInventoryLength())
        }
    }, [])

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    const weaponToolTip: IToolTipObject = {
        type: mainCharacter.getEquipment().weapon.getWeaponType(),
        name: mainCharacter.getEquipment().weapon.getName(),
        weaponDamage: mainCharacter.getEquipment().weapon.getWeaponDamage(),
        cost: mainCharacter.getEquipment().weapon.getCost()
    }

    return (
        <ul className="equipment__slots weapon">
            <li className="equipment__slot weapon" onClick={handleRemoveItem} onMouseEnter={() => callToolTip(toolTipContent)} onMouseLeave={() => setIsToolTipView(false)}>
                {mainCharacter.getEquipment().weapon.getImg().img ?
                    <>
                        <ImgWithFallback
                            classNames={'_isEquipped'}
                            src={mainCharacter.getEquipment().weapon.getImg().webp}
                            fallbackSrc={mainCharacter.getEquipment().weapon.getImg().img} />
                        {isToolTipView ?
                            <ToolTip
                                text=''
                                toolTipObjectContent={weaponToolTip}
                                position='top-inventory-items' />
                            :
                            null
                        }
                    </>
                    :
                    <ImgWithFallback src={WeaponSlotsWebp} fallbackSrc={WeaponSlots} />
                }
            </li>
            <li className="equipment__slot weapon">
                <ImgWithFallback src={shieldSlotsWebp} fallbackSrc={shieldSlots} />
            </li>
        </ul>
    );
};

export default CharacterWindowWeapon;